import { createFileRoute } from "@tanstack/react-router";
import { GarageGeneral } from "@/features/settings/garage-settings";

export const Route = createFileRoute("/settings/garage")({
  component: GarageGeneral,
});
